module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-inspection panel panel-default"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.activated == 0
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activated = 0
      }
    }
  }, [_vm._v("\n                Основные\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activated == 1
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activated = 1
      }
    }
  }, [_vm._v("\n                Комплектация\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activated == 2
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activated = 2
      }
    }
  }, [_vm._v("\n                Внешний осмотр\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activated == 3
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activated = 3
      }
    }
  }, [_vm._v("\n                Внутренний осмотр\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activated == 4
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activated = 4
      }
    }
  }, [_vm._v("\n                Тест драйв\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activated == 5
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.activated = 5
      }
    }
  }, [_vm._v("\n                Диагностика\n            ")])])]), _vm._v(" "), _c('inspection-main', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activated == 0),
      expression: "activated == 0"
    }],
    attrs: {
      "activated": "0",
      "inspection_id": _vm.inspection_id
    }
  }), _vm._v(" "), _c('inspection-equipment', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activated == 1),
      expression: "activated == 1"
    }],
    attrs: {
      "activated": "1",
      "inspection_id": _vm.inspection_id
    }
  }), _vm._v(" "), _c('inspection-external', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activated == 2),
      expression: "activated == 2"
    }],
    attrs: {
      "activated": "2",
      "inspection_id": _vm.inspection_id,
      "door_count": _vm.door_count
    }
  }), _vm._v(" "), _c('inspection-internal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activated == 3),
      expression: "activated == 3"
    }],
    attrs: {
      "activated": "3",
      "inspection_id": _vm.inspection_id
    }
  }), _vm._v(" "), _c('inspection-test-drive', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activated == 4),
      expression: "activated == 4"
    }],
    attrs: {
      "activated": "4",
      "inspection_id": _vm.inspection_id
    }
  }), _vm._v(" "), _c('inspection-diagnostic', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activated == 5),
      expression: "activated == 5"
    }],
    attrs: {
      "activated": "5",
      "inspection_id": _vm.inspection_id
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75214d34", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75214d34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TabsInspection.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-75214d34"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TabsInspection.vue
// module chunks = 0